import { memo } from 'react';

import { ViewVisibilityHeaderToggle } from '~/components/ViewControls/ViewVisiblityToggleMenu/shared/ViewVisibilityHeaderToggle';
import { useToggleNestedItems } from '~/hooks/search/useToggleNestedItems';

const EXPAND_NESTED_CONTENT_TOGGLE_ID = 'expandNestedContent';

export const ViewVisibilityExpandNestedContentToggle = memo(() => {
  const { isFlattenedView, toggleNestedItems } = useToggleNestedItems();

  return (
    <ViewVisibilityHeaderToggle
      id={EXPAND_NESTED_CONTENT_TOGGLE_ID}
      isToggleOn={isFlattenedView}
      label="Expand nested content"
      onToggle={toggleNestedItems}
    />
  );
});

ViewVisibilityExpandNestedContentToggle.displayName = 'ViewVisibilityExpandNestedContentToggle';
